import React from 'react';
import { Plus, ArrowUp, RotateCw } from 'lucide-react';

const MobileActionBar = ({ clearForm }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
      immediate: true
    });
  };

  const refreshPage = () => {
    window.location.href = window.location.href;
  };

  return (
    <div className="md:hidden fixed bottom-4 left-1/2 -translate-x-1/2 z-50">
      <div className="flex gap-4 p-2 rounded-full bg-white/80 backdrop-blur-md shadow-lg border border-slate-200">
        <button
          onClick={() => clearForm({ shouldConfirm: true, deleteImages: true, clearEditMode: true })}
          className="p-3 rounded-full bg-blue-500 text-white hover:bg-blue-600 transition-colors active:transform active:scale-95"
          aria-label="New report"
        >
          <Plus className="h-5 w-5" />
        </button>
        <button
          onClick={scrollToTop}
          className="p-3 rounded-full bg-blue-500 text-white hover:bg-blue-600 transition-colors active:transform active:scale-95"
          aria-label="Scroll to top"
        >
          <ArrowUp className="h-5 w-5" />
        </button>
        <button
          onClick={refreshPage}
          className="p-3 rounded-full bg-blue-500 text-white hover:bg-blue-600 transition-colors active:transform active:scale-95"
          aria-label="Refresh page"
        >
          <RotateCw className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default MobileActionBar; 